var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"d-flex align-end justify-sm-center flex-wrap"},[_c('img',{staticClass:"logo-img",attrs:{"src":require('@/assets/animate-logo-white.svg')}}),_c('p',{staticClass:"ma-0 logo-txt"},[_vm._v("EG pilots")])])}
var staticRenderFns = []

export { render, staticRenderFns }